const SkeletonProductPreview = () => {
  return (
    <div className="animate-pulse">
      <div className="aspect-[5/5] w-full bg-gray-100 bg-ui-bg-subtle rounded-large" />
      <div className="flex flex-col gap-y-2 mt-3">
        <div className="w-3/4 h-4 bg-gray-100 rounded" />
        <div className="w-1/4 h-4 bg-gray-100 rounded" />
      </div>
    </div>
  );
};

export default SkeletonProductPreview;
